import SeasonsStore from '../store/SeasonsStore';
import { fetchFromJson } from './fetchFromJson';

const db = new SeasonsStore('seasonsDb');

const updateCache = 'seasons_updateCache';
const getUpdateCache = (data) => data.seasons;
const toast = 'Seasons Updated';
const entityName = 'seasons';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});
